(function (angular) {
  "use strict";

  var MS_PER_SEC = 1000;
  var DEFAULT_MOUSE_FREQUENCY_THRESHOLD_HZ = 10;

  angular.module("Toyota.Services").service("MouseDetectionService", [
    "$rootScope",
    function ($rootScope) {
      var MouseDetectionAgent = function () {
        this.resetMouseFoundAndBuffer();
        this.startWatching();
        return this;
      };

      MouseDetectionAgent.prototype.timestampMsArrayLooksLikeMouseData = function (
        timestampMsArray,
        maxBufferSize,
        mouseFrequencyThresholdHz
      ) {
        var bufferFull = timestampMsArray.length === maxBufferSize;
        var bufferDurationThresholdMs = (maxBufferSize / mouseFrequencyThresholdHz) * MS_PER_SEC;
        if (bufferFull) {
          var firstTimestampMsInBuffer = timestampMsArray[0];
          var lastTimestampMsInBuffer = timestampMsArray[timestampMsArray.length - 1];
          if (bufferDurationThresholdMs >= lastTimestampMsInBuffer - firstTimestampMsInBuffer) {
            return true;
          }
        }

        return false;
      };

      MouseDetectionAgent.prototype.resetMouseFoundAndBuffer = function () {
        this.mouseMoveTimestampMsBuffer = [];
        this.mouseFound = false;
        $rootScope.$broadcast("did-lose-mouse");
      };

      MouseDetectionAgent.prototype.tellMouseFound = function () {
        this.mouseFound = true;
        $rootScope.$broadcast("did-detect-mouse");
      };

      MouseDetectionAgent.prototype.stopWatching = function () {
        angular.element("body").off("mousemove.MouseDetectionAgent");
      };

      MouseDetectionAgent.prototype.startWatching = function () {
        var self = this,
          maxBufferSize = 10;
        angular.element("body").on("mousemove.MouseDetectionAgent", function () {
          if (self.mouseMoveTimestampMsBuffer.length >= maxBufferSize) {
            self.mouseMoveTimestampMsBuffer.shift();
          }

          self.mouseMoveTimestampMsBuffer.push(new Date().valueOf());

          if (
            self.timestampMsArrayLooksLikeMouseData(
              self.mouseMoveTimestampMsBuffer,
              maxBufferSize,
              DEFAULT_MOUSE_FREQUENCY_THRESHOLD_HZ
            )
          ) {
            self.tellMouseFound();
            self.stopWatching();
          }
        });
      };

      return new MouseDetectionAgent();
    },
  ]);
})(window.angular);
